import { Timeline, Spin, Popover } from 'antd';
import { getData } from '@util';
import React, { useState, forwardRef } from 'react';
import { SUPPLIER_SELFT_SERVICE_PRODUCT_FLOW_RECORD } from '@api';
import _ from 'lodash';
import style from './style/index.scss';

export default forwardRef((props, ref) => {
  const [nodes, setNodes] = useState([]);
  const [loading, setLoading] = useState(false);

  const getApproveRecordList = async () => {
    const { record, mapkey } = props;
    setLoading(true);
    const res = await getData({
      api: SUPPLIER_SELFT_SERVICE_PRODUCT_FLOW_RECORD,
      searchParams: {
        flowId: mapkey ? record[mapkey] : record.flowId,
      },
    }).catch(err => {
      console.error(err);
      setNodes([<Timeline.Item>{err.message}</Timeline.Item>]);
      setLoading(false);
    });
    setLoading(false);
    return res;
  };
  const renderTimeLine = () => {
    setNodes([]);
    getApproveRecordList().then(res => {
      const { data: result } = res;
      const { historyApproves, nextApproves, latterApproves } = result;
      const arr = [];
      if (historyApproves?.length > 0) {
        historyApproves.forEach((item, index) => {
          arr.unshift(
            <Timeline.Item key={index + 1}>
              <div className={style.right}>
                <p>{new Date(item.approveTime).toLocaleDateString()}</p>
                <p>{new Date(item.approveTime).toLocaleTimeString('chinese', { hour12: false })}</p>
              </div>
              <div className={style.left}>
                <p
                  style={
                    item.result == 40
                      ? { color: 'green' }
                      : item.result == 30
                      ? { color: 'red' }
                      : null
                  }>
                  {' '}
                  {item.result == 20
                    ? '提交'
                    : item.result == 30
                    ? '驳回'
                    : item.result == 40
                    ? '审核通过'
                    : null}{' '}
                </p>
                {item.result == 30 ? <p>{item.resultDesc}</p> : null}
                <p>
                  {' '}
                  {item.nodeName}({item.approveUser}){' '}
                </p>
                <p>{item.resultDesc}</p>
                <p> {item.remark}</p>
              </div>
            </Timeline.Item>,
          );
        });
      }
      if (nextApproves?.length > 0) {
        nextApproves.forEach((item, index) => {
          arr.unshift(
            <Timeline.Item key={index + 'next' + 1}>
              <div className={style.right}>
                <p>下一节点</p>
              </div>
              <div className={style.left}>
                <p>{item.nodeName}</p>
                <p>{item.approveUsers.join()}</p>
              </div>
            </Timeline.Item>,
          );
        });
      }
      if (latterApproves?.length > 0) {
        latterApproves.forEach((item, index) => {
          arr.unshift(
            <Timeline.Item key={index + 'latter' + 1}>
              <div className={style.left}>
                <p>{item}</p>
              </div>
            </Timeline.Item>,
          );
        });
      }
      if (arr.length === 0) {
        arr.push(<p key={1}>暂无审核节点</p>);
      }
      setNodes(arr);
    });
  };

  return (
    <Popover
      trigger="click"
      onVisibleChange={visible => visible && renderTimeLine()}
      placement="right"
      content={
        <Spin spinning={loading}>
          {_.size(nodes) > 0 ? <Timeline className={style.timeLine}>{nodes}</Timeline> : '暂无数据'}
        </Spin>
      }>
      <a>{props.text}</a>
    </Popover>
  );
});
